export const DEFAULT_THEME = Object.freeze({
  id: 'default',
  primary: '#F26522',
});

export const DEFAULT_WIDTH = 957; // 950
export const DEFAULT_HERO_SIZE = 470; // 470
export const DEFAULT_HERO_SIZE_MOBILE = 368;
